// client/src/components/influencer/project/modals/ContractCompleteModal.js
import React from 'react';

function ContractCompleteModal({ open, onClose }) {
  if (!open) return null;

  return (
    <div className="influencer-contract-modal" style={{ zIndex: 1003 }} onClick={onClose}>
      <div className="influencer-contract-modal__content" style={{ maxWidth: 400 }} onClick={(e) => e.stopPropagation()}>
        <div className="contract-complete">
          {/* 성공 아이콘 */}
          <div className="contract-complete__icon">✓</div>

          {/* 제목 */}
          <h2 className="contract-complete__title">계약이 완료되었습니다!</h2>
          
          {/* 메시지 */}
          <div className="contract-complete__message">
            프로젝트 계약이 완료되었습니다.<br />
            결과물 제출 페이지에서 결과물을 제출해주세요.
          </div>

          {/* 확인 버튼 */}
          <button className="contract-complete__button" onClick={onClose}>
            확인
          </button>
        </div>
      </div>
    </div>
  );
}

export default ContractCompleteModal;

